const initTipleBlockBanner = () => {
    const tripleBlockBannerList = document.querySelectorAll("[data-triple-block-banner]");
    if (tripleBlockBannerList && tripleBlockBannerList.length > 0) {
        tripleBlockBannerList.forEach((tripleBlockBanner) => {
            const secondColumnBlocksList = tripleBlockBanner.querySelectorAll("[data-second-column-block]");
            if (secondColumnBlocksList && secondColumnBlocksList.length > 0) {
                secondColumnBlocksList.forEach((secondColumnBlock) => {
                    const cta = secondColumnBlock.querySelector(".cta");
                    const modal = secondColumnBlock.querySelector("[data-modal]");
                    const closeIconModal = modal.querySelector(".close-icon");
                    cta.addEventListener("click", (e) => {
                        e.preventDefault();
                        if (!modal.classList.contains("active")) {
                            modal.classList.add("active");
                            modal.classList.remove("not-visible");
                        }
                        else {
                            modal.classList.remove("active");
                            modal.classList.add("not-visible");
                        }
                    });
                    closeIconModal.addEventListener("click", () => {
                        if (!modal.classList.contains("active")) {
                            modal.classList.add("active");
                            modal.classList.remove("not-visible");
                        }
                        else {
                            modal.classList.remove("active");
                            modal.classList.add("not-visible");
                        }
                    });
                });
            }
        });
    }
};
